module.exports = __webpack_public_path__ + "img/airdutemps.fbabdd43.png";